// Single source of truth for legal/company details shown across the site.
//
// Two addresses, two jobs:
//   COMPANY.*    → the public-facing / production address (Houston, TX). This is
//                  what customers see in the footer, on invoices and in emails.
//   COMPANY.hq.* → the registered headquarters in Sheridan, WY. Kept for legal
//                  pages (governing law, registered mailing address) only.
export const COMPANY = {
  brand: "KoltPrinting",
  legalName: "Koltprinting LLC",
  city: "Houston",
  state: "TX",
  stateLong: "Texas",
  country: "US",
  phoneDisplay: "(346) 458-0808",
  phoneTel: "+13464580808",
  phoneSchema: "+1-346-458-0808",
  emails: {
    support: "support@koltprinting.com",
    estimate: "estimate@koltprinting.com",
    accounting: "accounting@koltprinting.com",
    privacy: "support@koltprinting.com",
  },
  site: "https://www.koltprinting.com",
  productionCity: "Houston, TX",
  legalUpdated: "June 1, 2026",
  hq: {
    legalName: "Koltprinting LLC",
    street: "1309 Coffeen Avenue",
    city: "Sheridan",
    state: "WY",
    stateLong: "Wyoming",
    zip: "82801",
    country: "US",
  },
};

// "Houston, TX" — production-only shop, no walk-in street address published.
export const COMPANY_ADDRESS_LINE = `${COMPANY.city}, ${COMPANY.state}`;

export const COMPANY_HQ_LINE =
  `${COMPANY.hq.street}, ${COMPANY.hq.city}, ${COMPANY.hq.state} ${COMPANY.hq.zip}, ${COMPANY.hq.country}`;

export const LEGAL_LINKS = [
  ["Privacy Policy", "/privacy"],
  ["Terms & Conditions", "/terms"],
  ["Refund & Reprint Policy", "/refund-policy"],
];
